"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _card = _interopRequireDefault(require("../card"));

var _Document = _interopRequireDefault(require("../svg/icons/Document"));

var _caseStudyModule = _interopRequireDefault(require("./caseStudy.module.css"));

const CaseStudies = _ref => {
  let {
    title,
    description,
    url,
    logo,
    displayBorder,
    downloadText = 'Download'
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("a", {
    className: _caseStudyModule.default.download,
    href: url,
    download: true,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react.default.createElement(_card.default, {
    square: true,
    className: (0, _clsx.default)(_caseStudyModule.default.cardContainer, displayBorder && _caseStudyModule.default.border)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _caseStudyModule.default.content
  }, logo ? /*#__PURE__*/_react.default.createElement("div", {
    className: _caseStudyModule.default.imageContainer
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: _caseStudyModule.default.logo,
    src: logo,
    alt: "Company Logo"
  })) : /*#__PURE__*/_react.default.createElement(_Document.default, {
    className: _caseStudyModule.default.icon
  }), logo ? null : /*#__PURE__*/_react.default.createElement("span", {
    className: _caseStudyModule.default.title
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: _caseStudyModule.default.description
  }, description), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _clsx.default)(_caseStudyModule.default.downloadText, logo && _caseStudyModule.default.withLogo)
  }, downloadText))));
};

CaseStudies.defaultProps = {
  title: '',
  logo: '',
  displayBorder: false,
  downloadText: 'Download'
};
CaseStudies.propTypes = {
  title: _propTypes.default.string,
  description: _propTypes.default.string.isRequired,
  url: _propTypes.default.string.isRequired,
  logo: _propTypes.default.string,
  displayBorder: _propTypes.default.bool,
  downloadText: _propTypes.default.string
};
var _default = CaseStudies;
exports.default = _default;